'use strict';

/**
 *
 * @name: TranslationsLoaderRun
 *
 */

function TranslationsLoaderRun($location, $rootScope, $translate) {

  'ngInject';

  const splittedHostname = window.location.hostname.split('.');
  const topLevelDomain = splittedHostname[splittedHostname.length - 1];
  let lang = 'zh-cn';
  let lang2 = 'zh-cn'
  const paramLang = $location.$$search.devLang;
  const ssLang = sessionStorage.getItem('NN_lang');
  const ssLang2 = sessionStorage.getItem('NN_lang2');

  if(!paramLang) {
    if (topLevelDomain === 'cn') {
      lang = 'zh-cn';
      lang2 = 'zh_cn';
    } else if (topLevelDomain === 'hk' || topLevelDomain === 'asia') {
      lang = 'zh-hk';
      lang2 = 'zh_hk';
    } else if (topLevelDomain === 'com') {
      lang = 'en-us';
      lang2 = 'en_us';
    } else if (ssLang) {
      lang = ssLang
      lang2 = ssLang2
    }
  } else {
    if(paramLang === 'zh-cn'){
      lang = 'zh-cn';
      lang2 = 'zh_cn';
    } else if (paramLang === 'zh-hk') {
      lang = 'zh-hk';
      lang2 = 'zh_hk';
    }else if (paramLang === 'en-us') {
      lang = 'en-us';
      lang2 = 'en_us';
    }
  }

  sessionStorage.setItem('NN_lang', lang);
  sessionStorage.setItem('NN_lang2', lang2);

  $rootScope.lang = lang;
  $rootScope.lang2 = lang2;
  $translate.use(lang);

  // ENGLISH
  if (lang === 'en-us') {
    moment.lang('en', {
      calendar: {
        lastDay: '[Yesterday]',
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        lastWeek: '',
        nextWeek: '',
        sameElse: ''
      }
    });

    $rootScope.followerCounterText = {
      '0': 'No followers',
      '1': '1 Follower',
      'other': '{{ user["followersCount_' + $rootScope.lang2 + '"] }} Followers'
    };
    $rootScope.playlistVideoCount = {
      '0': 'No videos',
      '1': '1 video',
      'other': '{{ playlist.videosCount }} videos'
    };

    moment.fn.fromNowOrNow = function(a) {
      if (Math.abs(moment().diff(this)) < 45000) { // 25 seconds before or after now
        return 'just now';
      }
      return this.fromNow(a);
    };
  }

  // ENGLISH + HONGKONG
  if (lang === 'en-us' || lang === 'zh-hk') {
    $rootScope.storyCount = {
      '0': '0 stories',
      '1': '1 story',
      'other': '{{ TAGC.totalItems }} stories'
    };
  }

  // CHINESE + HONGKONG
  if (lang === 'zh-cn' || lang === 'zh-hk') {

    moment.lang('zh-cn', {
      calendar: {
        lastDay: '[昨天]',
        sameDay: '[今天]',
        nextDay: '[明天]',
        lastWeek: '',
        nextWeek: '',
        sameElse: ''
      }
    });

    $rootScope.followerCounterText = {
      '0': '0位关注我的人',
      '1': '1位关注我的人',
      'other': '{{ user["followersCount_' + $rootScope.lang2 + '"] }}位关注我的人'
    };

    $rootScope.playlistVideoCount = {
      '0': '0个视频',
      '1': '1个视频',
      'other': '{{ playlist.videosCount }}个视频'
    };

    moment.fn.fromNowOrNow = function(a) {
      if (Math.abs(moment().diff(this)) < 45000) { // 25 seconds before or after now
        return 'just now';
      }
      return this.fromNow(a);
    };
  }

  // CHINESE
  if (lang === 'zh-cn') {
    $rootScope.storyCount = {
      '0': '0故事',
      '1': '1故事',
      'other': '{{ TAGC.totalItems }}故事'
    };
  }
}

export default TranslationsLoaderRun;



// WEBPACK FOOTER //
// ./app/components/nn-translations/nn-translations-loader.run.js